import React, { useState } from "react";
import {
  BackgroundDiv,
  BottomBtn,
  ContentBody,
  DivSelectBoxArea,
  DivSelectBoxTitle,
  HeaderTitle,
  NoticeText,
  SelectDivArea,
} from "./ReceiptStyle";
import { _O } from "../../../modules/utils";
import ArrowLeft from "../../../resources/images/nftf/arrow-left.svg";
import MedicalCard from "../MedicalCard/MedicalCard";
import { CheckIcon, Checkbox } from "../Modal/ModalStyle";
import { IC } from "../../../resources/Assets";

const ReceiptComplete = (props) => {
  const { submit, hsptInfo, trgtInfo, smptInfo, cardInfo } = props;
  const [toggle, setToggle] = useState(false);
  const [nftfData, setNftfData] = useState(convertNftfData());

  const toggleCheck = () => {
    if (toggle) {
      submit();
    } else {
      alert("개인정보 수집 및 제공에 동의하세요");
    }
  };

  return (
    <BackgroundDiv>
      <HeaderTitle>
        <div style={{ width: "40px", height: "40px" }} onClick={() => props.setPageIdx(1)}>
          {/* <img src={ArrowLeft} /> */}
          <img src={IC.etc.ICON_CHEVRON_LEFT} />
        </div>
        <div>비대면진료 접수</div>
        <div style={{ width: "40px", height: "40px" }}>{/* <img src={ArrowLeft} /> */}</div>
      </HeaderTitle>
      <ContentBody>
        <NoticeText>
          비대면 진료가
          <br />
          접수되었습니다
        </NoticeText>

        <SelectDivArea>
          <DivSelectBoxTitle>
            케어포미 홈 {">"} 병원/비대면진료예약 {">"} 예약현황 <br /> 에서 확인하실 수 있습니다
          </DivSelectBoxTitle>
          {nftfData && <MedicalCard nftfData={nftfData} />}
        </SelectDivArea>
      </ContentBody>

      <Checkbox style={{ bottom: "106px", position: "absolute", padding: "0 20px" }}>
        {/* <input type="checkbox" onClick={() => setToggle(!toggle)} hidden /> */}
        <CheckIcon type="checkbox" onClick={() => setToggle(!toggle)} />
        개인정보 수집 및 제공에 동의합니다
      </Checkbox>

      <BottomBtn onClick={() => toggleCheck()}>예약</BottomBtn>
    </BackgroundDiv>
  );
};

const convertNftfData = (hsptInfo, trgtInfo, smptInfo, cardInfo) => {
  let returnData = {
    appComm: "",
    appDelayTime: "2023-07-26 09:10",
    appDrName: "류대선",
    appStatus: 1,
    appStatusNm: "예약대기",
    appTime: "Jul 26, 2023 9:10:00 AM",
    delayRsn: "",
    delayTerm: "",
    hsptNm: "미라벨검증",
    hsptTelNo: "18774872",
    procDh: "",
    rejctRsn: "",
    resrvNo: "",
    seqNo: 1093,
    symtmDesc: "",
    tmDiff: "",
  };

  return returnData;
};

export default ReceiptComplete;
